/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-23T16:04:05.431
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-channelpic-'

export default 
{
path: '/rentmanage/channelpic',
name: 'rentmanage-channelpic',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}channelpic-index',

meta:{
...meta,
title: '房源设施'
},

component: () => import('@/pages/rentmanage/channelpic/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}channelpic-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源设施编辑'
},

component: () => import('@/pages/rentmanage/channelpic/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}channelpicdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源设施新增'
},

component: () => import('@/pages/rentmanage/channelpic/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}channelpicView',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源设施详情查看'
},

component: () => import('@/pages/rentmanage/channelpic/detail-view') ,
},
]
};
